export default __webpack_public_path__ + "static/media/E0006.e5df1b3c.png";